(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-text-block"] && !Shopify.designMode) return;
  try {
    
window.addEventListener('DOMContentLoaded', function () {
  new Swiper('.review-swiper', {
    loop: true,
    spaceBetween: 20,

    // Mobile
    slidesPerView: 1.3,

    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },

    navigation: false,

    breakpoints: {
      // Tablet
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },

      // Desktop
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
  });
});

  } catch(e) { console.error(e); }
})();
})();
